import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoAdultContentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"no_adult_content"}/>
}
